import * as React from 'react'

interface Props {
  pageContext: {
    securities: string[]
  }
}

export default function StockReport({ pageContext: { securities } }: Props) {
  return (
    <ul>
      {securities.map((p) => (
        <li>
          <a href={`/share-prices${p}`}>{p}</a>
        </li>
      ))}
    </ul>
  )
}
